import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  stroke: "#000",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "inherit",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "clip-path": "url(#download_svg__a)"
    }, [
      _createElementVNode("path", { d: "M10 12.258v7.031m2.93-2.929L10 19.29l-2.93-2.93m6.446-2.93h1.465a3.81 3.81 0 1 0-2.16-6.942 5.86 5.86 0 1 0-6.366 6.91" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "download_svg__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }